import { useState } from "react";
import { Download, Search } from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const LogsIndex = () => {
  const [search, setSearch] = useState("");

  const logs = [
    { id: 1, time: "2026-03-24 10:00", user: "Admin", action: "Created Company", module: "Company", status: "Success" },
    { id: 2, time: "2026-03-24 11:00", user: "Admin", action: "Deleted Plan", module: "Plan", status: "Error" },
    { id: 3, time: "2026-03-24 12:00", user: "QA", action: "Updated Feature", module: "Feature", status: "Success" },
    { id: 4, time: "2026-03-24 13:00", user: "System", action: "API Failed", module: "System", status: "Error" },
  ];

  const stats = [
    { label: "Total Logs", value: 1200 },
    { label: "Success", value: 980 },
    { label: "Errors", value: 180 },
    { label: "Warnings", value: 40 },
  ];

  const chartData = [
    { name: "Mon", logs: 40 },
    { name: "Tue", logs: 60 },
    { name: "Wed", logs: 30 },
    { name: "Thu", logs: 80 },
    { name: "Fri", logs: 50 },
  ];

  const downloadCSV = () => {
    const csv = [
      ["Time", "User", "Action", "Module", "Status"],
      ...logs.map((l) => [l.time, l.user, l.action, l.module, l.status]),
    ]
      .map((e) => e.join(","))
      .join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "logs.csv";
    a.click();
  };

  return (
    <div className="container mt-4">

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Monitoring & Logs</h4>
        <button className="btn btn-primary" onClick={downloadCSV}>
          <Download size={16} /> Download CSV
        </button>
      </div>

      {/* Filters */}
      <div className="card p-3 mb-3">
        <div className="d-flex gap-3 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <Search size={16} />
            <input
              className="form-control"
              placeholder="Search logs..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <select className="form-select" style={{ maxWidth: 180 }}>
            <option>All Logs</option>
            <option>Audit</option>
            <option>System</option>
            <option>Security</option>
          </select>

          <select className="form-select" style={{ maxWidth: 180 }}>
            <option>Status</option>
            <option>Success</option>
            <option>Error</option>
          </select>

          <input type="date" className="form-control" style={{ maxWidth: 180 }} />
        </div>
      </div>

      {/* Stats */}
      <div className="row mb-3">
        {stats.map((item, i) => (
          <div className="col-md-3" key={i}>
            <div className="card p-3 shadow-sm">
              <h6>{item.label}</h6>
              <h4>{item.value}</h4>
            </div>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div className="card p-3 mb-3">
        <h5>Logs Activity</h5>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="logs" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Table */}
      <div className="card p-3">
        <h5>Logs List</h5>
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Time</th>
                <th>User</th>
                <th>Action</th>
                <th>Module</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{log.id}</td>
                  <td>{log.time}</td>
                  <td>{log.user}</td>
                  <td>{log.action}</td>
                  <td>{log.module}</td>
                  <td>
                    <span
                      className={`badge ${
                        log.status === "Success"
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {log.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>

    </div>
  );
};

export default LogsIndex;